import { Box, Typography } from "@mui/material";
import { type Control, useWatch } from "react-hook-form";
import {
  MAX_TEXT_LENGTH,
  type StoryFormData,
} from "Schemas/Stories/storyFormSchema";

type Props = {
  control: Control<StoryFormData>;
};

/** Live "n / max" under the story text; watches the field here so typing re-renders only this. */
export const StoryTextCounter = ({ control }: Props) => {
  const text = useWatch({ control, name: "text" });

  return (
    <Box display="flex" justifyContent="flex-end" component="span">
      <Typography variant="body2" color="text.secondary" component="span">
        {`${text.length} / ${MAX_TEXT_LENGTH}`}
      </Typography>
    </Box>
  );
};
